"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "3.3.15.11", "build_date": "2026-02-27T10:47:27.749Z", "build_branch": "development", "build_commit": "9cc59445ab0b1e9d9ad2d59319edca3a248ca1e6" };
//# sourceMappingURL=build_data.js.map